import { render, staticRenderFns } from "./TabTitle.vue?vue&type=template&id=18ba00e2&scoped=true"
import script from "./TabTitle.vue?vue&type=script&lang=js"
export * from "./TabTitle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18ba00e2",
  null
  
)

export default component.exports